export default __webpack_public_path__ + "static/media/menu_scenarios.e559d341.svg";